import axios from "axios"
import { authHeader } from "../../utils"
import { CREATE_INVENTORY_ITEM, CREATE_INVENTORY_ITEM_ASSIGNMENT, CREATE_INVENTORY_ITEM_CATEGORY, CREATE_INVENTORY_ITEM_VARIANT, CREATE_INVENTORY_LOCATION, CREATING_INVENTORY_ITEM, CREATING_INVENTORY_ITEM_ASSIGNMENT, CREATING_INVENTORY_ITEM_CATEGORY, CREATING_INVENTORY_LOCATION, DELETE_INVENTORY_ITEM_CATEGORY, DELETE_INVENTORY_LOCATION, DELETING_INVENTORY_ITEM_CATEGORY, DELETING_INVENTORY_LOCATION, GET_INVENTORY_ITEM_ASSIGNMENT, GET_INVENTORY_ITEM_CATEGORIES, GET_INVENTORY_ITEM_VARIANTS, GET_INVENTORY_ITEMS, GET_INVENTORY_LOCATIONS, GETTING_INVENTORY_ITEM_ASSIGNMENT, GETTING_INVENTORY_ITEM_CATEGORIES, GETTING_INVENTORY_ITEM_VARIANTS, GETTING_INVENTORY_ITEMS, GETTING_INVENTORY_LOCATIONS, INVENTORY_ERROR, SET_SUCCESS, UPDATE_INVENTORY_ITEM, UPDATE_INVENTORY_ITEM_CATEGORY, UPDATE_INVENTORY_ITEM_VARIANT, UPDATE_INVENTORY_LOCATION, UPDATING_INVENTORY_ITEM, UPDATING_INVENTORY_ITEM_CATEGORY, UPDATING_INVENTORY_ITEM_VARIANT, UPDATING_INVENTORY_LOCATION } from "../types"

export const createInventoryLocation = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVENTORY_LOCATION,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/inventory/locations`, payload, { headers })
        
        dispatch({
            type: CREATE_INVENTORY_LOCATION,
            payload: response.data.data
        })

        dispatch({
            type: SET_SUCCESS,
            payload: "New inventory location created successfully!"
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearCreatedInventoryLocation = () => async (dispatch) => {    
    dispatch({
        type: CREATING_INVENTORY_LOCATION,
        payload: null
    })
}

export const updateInventoryLocation = (id, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_INVENTORY_LOCATION,
            payload: true
        })
        const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/inventory/locations/${id}`, payload, { headers })
        
        dispatch({
            type: UPDATE_INVENTORY_LOCATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearUpdatedInventoryLocation = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_INVENTORY_LOCATION,
        payload: null
    })
}

export const deleteInventoryLocation = (id) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_INVENTORY_LOCATION,
            payload: true
        })
        const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/inventory/locations/${id}`, { headers })
        
        dispatch({
            type: DELETE_INVENTORY_LOCATION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearDeletedInventoryLocation = () => async (dispatch) => {    
    dispatch({
        type: DELETE_INVENTORY_ITEM_CATEGORY,
        payload: null
    })
}

export const fetchInventoryLocations = (filters, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `inventory/locations?expand=approvers`
        if((page || page===0) && page !== ''){
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }
        if((perPage || perPage === 0) && perPage !== ''){
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch({
            type: GETTING_INVENTORY_LOCATIONS,
            payload: true
        })
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}`, { headers })

        dispatch({
            type: GET_INVENTORY_LOCATIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}


export const createInventoryItemCategory = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVENTORY_ITEM_CATEGORY,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/inventory/categories`, payload, { headers })
        
        dispatch({
            type: CREATE_INVENTORY_ITEM_CATEGORY,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearCreatedInventoryItemCategory = () => async (dispatch) => {    
    dispatch({
        type: CREATE_INVENTORY_ITEM_CATEGORY,
        payload: null
    })
}

export const updateInventoryItemCategory = (categoryId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_INVENTORY_ITEM_CATEGORY,
            payload: true
        })
        const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/inventory/categories/${categoryId}`, payload, { headers })
        
        dispatch({
            type: UPDATE_INVENTORY_ITEM_CATEGORY,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearUpdatedInventoryItemCategory = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_INVENTORY_ITEM_CATEGORY,
        payload: null
    })
}

export const deleteInventoryItemCategory = (categoryId) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: DELETING_INVENTORY_ITEM_CATEGORY,
            payload: true
        })
        const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/inventory/categories/${categoryId}`, { headers })
        
        dispatch({
            type: DELETE_INVENTORY_ITEM_CATEGORY,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearDeletedInventoryItemCategory = () => async (dispatch) => {    
    dispatch({
        type: DELETE_INVENTORY_ITEM_CATEGORY,
        payload: null
    })
}

export const getInventoryItemCategories = (page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `inventory/categories`
        if((page || page===0) && page !== ''){
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }
        if((perPage || perPage === 0) && perPage !== ''){
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch({
            type: GETTING_INVENTORY_ITEM_CATEGORIES,
            payload: true
        })
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}`, { headers })

        dispatch({
            type: GET_INVENTORY_ITEM_CATEGORIES,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const createInventoryItem = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVENTORY_ITEM,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/inventory/items`, payload, { headers })
        
        dispatch({
            type: CREATE_INVENTORY_ITEM,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearCreatedInventoryItem = () => async (dispatch) => {    
    dispatch({
        type: CREATE_INVENTORY_ITEM,
        payload: null
    })
}

export const updateInventoryItem = (itemId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_INVENTORY_ITEM,
            payload: true
        })
        const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/inventory/items/${itemId}`, payload, { headers })
        
        dispatch({
            type: UPDATE_INVENTORY_ITEM,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearUpdatedInventoryItem= () => async (dispatch) => {    
    dispatch({
        type: UPDATE_INVENTORY_ITEM,
        payload: null
    })
}

export const getInventoryItems = (page, perPage, filter) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `inventory/items?expand=category`
        if((page || page===0) && page !== ''){
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }
        
        if((perPage || perPage === 0) && perPage !== ''){
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        if(filter && filter !== ''){
            url += `${url.includes('?') ? '&' : '?'}${filter}`
        }

        dispatch({
            type: GETTING_INVENTORY_ITEMS,
            payload: true
        })

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}`, { headers })

        dispatch({
            type: GET_INVENTORY_ITEMS,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const createInventoryItemAssignment = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVENTORY_ITEM_ASSIGNMENT,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/inventory/item-assignments`, payload, { headers })
        
        dispatch({
            type: CREATE_INVENTORY_ITEM_ASSIGNMENT,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearCreatedInventoryItemAssignment = () => async (dispatch) => {    
    dispatch({
        type: CREATE_INVENTORY_ITEM_ASSIGNMENT,
        payload: null
    })
}

export const getInventoryItemAssignments = (page, perPage, filter) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `inventory/item-assignments?expand=item,variant,department,employee`
        if((page || page===0) && page !== ''){
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }
        
        if((perPage || perPage === 0) && perPage !== ''){
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        if(filter && filter !== ''){
            url += `${url.includes('?') ? '&' : '?'}${filter}`
        }

        dispatch({
            type: GETTING_INVENTORY_ITEM_ASSIGNMENT,
            payload: true
        })

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}`, { headers })

        dispatch({
            type: GET_INVENTORY_ITEM_ASSIGNMENT,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const createInventoryItemVariant = (payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_INVENTORY_ITEM,
            payload: true
        })
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/inventory/item-variants`, payload, { headers })
        
        dispatch({
            type: CREATE_INVENTORY_ITEM,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearCreatedInventoryItemVariant = () => async (dispatch) => {    
    dispatch({
        type: CREATE_INVENTORY_ITEM_VARIANT,
        payload: null
    })
}

export const updateInventoryItemVariant = (variantId, payload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: UPDATING_INVENTORY_ITEM_VARIANT,
            payload: true
        })
        const response = await axios.patch(`${process.env.REACT_APP_BASE_URL}/inventory/item-variants/${variantId}`, payload, { headers })
        
        dispatch({
            type: UPDATE_INVENTORY_ITEM_VARIANT,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

export const clearUpdatedInventoryItemVariant = () => async (dispatch) => {    
    dispatch({
        type: UPDATE_INVENTORY_ITEM_VARIANT,
        payload: null
    })
}

export const getInventoryItemVariants = (page, perPage, filter) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `inventory/item-variants?expand=item,category`
        if((page || page===0) && page !== ''){
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }
        
        if((perPage || perPage === 0) && perPage !== ''){
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        if(filter && filter !== ''){
            url += `${url.includes('?') ? '&' : '?'}${filter}`
        }

        dispatch({
            type: GETTING_INVENTORY_ITEM_VARIANTS,
            payload: true
        })

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}`, { headers })

        dispatch({
            type: GET_INVENTORY_ITEM_VARIANTS,
            payload: response.data.data
        })
    }
    catch(error){
        dispatch({
            type: INVENTORY_ERROR,
            error
        })
    }
}

